export enum ShapeKeys {
  SHAPE_TYPE,
  STATE,
  SEAT_ID
}
